export const NAV_LABEL_OPTIONS = {
  LOGOUT: 'Logout',
};
